<template>
  <div class="recommand">
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="noDataTip notice" v-if="recomendInfo.length===0">
        <dl>
          <dt></dt>
          <dd style="width:100%;text-align:center;">暂无数据</dd>
        </dl>
     </div>
     <ul class="recommand-list">
        <li v-for="(item, index) in recomendInfo" :key="index">
            <span>
                {{item.name}}
            </span>
            <span>扫码关注</span>
            <span>{{item.time}}</span>
        </li>
     </ul>
    </cube-scroll>
  </div>
</template>
<script>
export default {
  name: 'recommend',
  data () {
    return {
      user_id: localStorage.getItem('user_id'),
      userType: this.$route.params.userType,
      recomendInfo: [],
      items: [],
      options: {
        pullUpLoad: {
          threshold: 0,
          txt: {
            more: '加载更多',
            noMore: '没有更多了'
          },
          stop:true,
        },
        pullDownRefresh: {
          threshold: 60,
          txt: '刷新成功'
        },
      },
    }
  },
  created () {
    this.$loading.show()
    this.getInit(1,1)
  },
  methods: {
    // doctorOrders
    getInit (pageNum, type) {
      let _this = this
      // if(this.userType == 2){
        // 业务端
        this.$http.api.finduser({
          page: pageNum,
          size: 10,
          user_id: this.user_id
        }).then( result => {
          // this.recomendInfo = [...result.rows]
          // console.log(result)
          this.$loading.hide()
          _this.allpage = Math.ceil(result.total/10)
          let data = result.rows
          if (type === 1) {
            _this.recomendInfo = [...data]
            _this.$refs.scroll.forceUpdate()
            _this.pageNum = 2
          } else {
            if (data.length > 0 && _this.pageNum <= _this.allpage) {
              _this.recomendInfo = _this.recomendInfo.concat(data)
              _this.pageNum = _this.pageNum + 1
              _this.$refs.scroll.forceUpdate()
            }
          }
        })
        if( _this.pageNum > _this.allpage){
          setTimeout(function () {
            _this.$refs.scroll.forceUpdate()
          }, 300)
        }
      // }else if(this.userType == 1){
      //   // 医生端
      //   this.$http.api.doctorOrders({
      //     page: pageNum,
      //     size: 10,
      //     user_id: this.user_id
      //   }).then( result => {
      //     // this.recomendInfo = [...result.rows]
      //     // console.log(result)
      //     _this.allpage = Math.ceil(result.total/10)
      //     let data = result.rows
      //     if (type === 1) {
      //       _this.recomendInfo = [...data]
      //       _this.$refs.scroll.forceUpdate()
      //       _this.pageNum = 2
      //     } else {
      //       if (data.length > 0 && _this.pageNum <= _this.allpage) {
      //         _this.recomendInfo = _this.recomendInfo.concat(data)
      //         _this.pageNum = _this.pageNum + 1
      //         _this.$refs.scroll.forceUpdate()
      //       }
      //     }
      //   })
      //   if( _this.pageNum > _this.allpage){
      //     setTimeout(function () {
      //       _this.$refs.scroll.forceUpdate()
      //     }, 300)
      //   }
      // }
    },
    onPullingDown () {
      // this.isLoading = false
      this.getInit(1, 1)
    },
    onPullingUp () {
      let _this = this
      // _this.isLoading = false
      setTimeout(function () {
        _this.getInit(_this.pageNum, 2)
      }, 800)
    },
  }
}
</script>
<style lang="less" scoped>
.recommand{
  width: 100%;
  overflow: hidden;
  .recommand-list {
    padding: 0 10px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 15px;
    li{
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #fff;
      margin-bottom: 5px;
      border-radius: 1px;
      border:1px solid rgba(0, 0, 0, 0.1);
      span{
          width: 33.33%;
          display: inline-block;
          height: 40px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
          &:nth-child(1){

          }
      }
    }
  }
}
.noDataTip{
  width: 100%;
  text-align: center;
  padding-top: 30px;
}
</style>


